import { OPEN_MODAL, CLOSE_MODAL, CLOSE_ALL_MODALS, UPDATE_MODAL } from './modal-actions';

const initialState = [];

export const modal = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return [...state, action.payload];
    case UPDATE_MODAL: {
      const changedModals = [
        ...state
          .filter(item => item.key === action.payload.modalkey)
          .map(newModal => {
            return { ...newModal, [action.payload.targetPropName]: action.payload.newValue };
          })
      ];

      const oldModals = [...state.filter(item => item.key !== action.payload.modalkey)];
      return [...oldModals, ...changedModals];
    }
    case CLOSE_MODAL:
      return state.slice(0, -1);

    case CLOSE_ALL_MODALS:
      return initialState;

    default:
      return state;
  }
};
